import type {
  ComponentProps,
  Ref,
} from "react"
import { forwardRef } from "react"
import { IconButtonLabel } from "../IconButtonLabel"
import styles from "./AddImageButton.module.scss"
import { CameraFillIcon } from "src/icons"
import { UnstyledInput } from "src/inputs/UnstyledInputs"
import type { InputLabelProps } from "src/types"


export interface Props extends InputLabelProps {
  accept?: ComponentProps<"input">["accept"];
  capture?: ComponentProps<"input">["capture"];
}

// pass "src" instead of "value"
export const AddImageButton = forwardRef<HTMLLabelElement, Props>(
  function AddImageButton(props: Props, propRef: Ref<HTMLLabelElement>) {
    const {
      accept = "image/*", // specifies that only image files are permitted
      capture = "environment", // specifies that phones should use the outward facing camera
      disabled,
      htmlFor,
      inputRef,
      name: inputName,
      onChange,
      required,
      value,
      src,
      ...htmlProps
    } = props

    return (
      <>
        <UnstyledInput
          accept={accept}
          capture={capture}
          className={styles.addImageButton}
          disabled={disabled}
          id={htmlFor}
          name={inputName}
          onChange={onChange}
          ref={inputRef}
          required={required}
          type="file"
          value={value}
          src={src}
        />
        <IconButtonLabel
          {...htmlProps}
          htmlFor={htmlFor}
          ref={propRef}
        >
          <CameraFillIcon />
        </IconButtonLabel>
      </>
    )
  },
)
